import React, { useState, useEffect } from 'react';
import MediaExplorerDataPanel from './MediaExplorerDataPanel';
import MediaExplorerSidePanel from './MediaExplorerSidePanel';

const MediaExplorer = ({ publication, setPublication }) => {
  const [loading, setLoading] = useState(false);
  const media_types = [];
  //     'Newspapers',
  //     'Magazines',
  //     'News Channels',
  //     'Radio',
  //     'Blog',
  //     'Podcast'
  //   ];

  useEffect(() => {
    if (!publication) {
      const mediaScopeElement = document.getElementById('media-scope');
      if (mediaScopeElement) {
        setPublication(mediaScopeElement.getAttribute('data-publication'));
      }
    }
  }, []);

  return (
    <>
      <div className="u--background-color-white u--padding-top-30 u--padding-bottom-30">
        <div className="media-explorer--header u--text-align-center u--padding-top-30 u--padding-bottom-30">
          <h2 className="h3">
            Discover the most popular readership by news source.
          </h2>
          <p>
            Select a news source and get valuable insights into media
            consumption trends.
          </p>
          <div className="media-types">
            {media_types.map((media_type) => (
              <button
                key={media_type}
                className="btn btn--gray-lightest u--margin-right-10"
              >
                {media_type}
              </button>
            ))}
          </div>
        </div>
        <div className="grid u--margin-left-20 u--margin-top-30 u--margin-right-20">
          <div className="grid__col-xs-12 grid__col-lg-4 u--order-2-md-max">
            <MediaExplorerSidePanel
              publication={publication}
              setPublication={setPublication}
              loading={loading}
              setLoading={setLoading}
            />
          </div>
          <div className="grid__col-xs-12 grid__col-lg-8">
            <MediaExplorerDataPanel
              publication={publication}
              loading={loading}
              setLoading={setLoading}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default MediaExplorer;
